export const MONTHS_IN_A_YEAR = 12
export const BENEFIT_GROUP = "Employer Benefit"

export const RADIO_VALUE_YES = "true"
export const RADIO_VALUE_NO = "false"

export const RADIO_LABEL_YES = "Yes"
export const RADIO_LABEL_NO = "No"

export const VAT_RADIO_OPTIONS = [
  { label: RADIO_LABEL_YES, value: RADIO_VALUE_YES },
  { label: RADIO_LABEL_NO, value: RADIO_VALUE_NO },
]
